import { capitalize } from "./capitalize";

export const normalizeColumnValue = (
  val: unknown,
  defaultValue: string | number = "N/A",
  shouldCapitamize: boolean = true,
): string | number => {
  // Handle null or undefined
  if (val === null || val === undefined) return defaultValue;

  // Handle numbers — always return 0 if NaN
  if (typeof val === "number") return isNaN(val) ? 0 : val;

  // Handle strings — trim, capitalize, or return default
  if (typeof val === "string") {
    const trimmed = val.trim();
    if (trimmed === "") {
      return defaultValue;
    } else if (shouldCapitamize) {
      return capitalize(trimmed);
    }
    return trimmed;
  }

  // Handle arrays — join or fallback
  if (Array.isArray(val)) {
    return val.length > 0 ? val.join(", ") : defaultValue;
  }

  // Handle objects — optional summary or fallback
  if (typeof val === "object") {
    const entries = Object.entries(val as Record<string, unknown>);
    return entries.length > 0
      ? `${entries[0][0]}: ${entries[0][1]}`
      : defaultValue;
  }

  return defaultValue;
};
